import { $session } from "./session.js";

const $router =
	{
		// ------------------------------------
		// 라우트 이동시 세션 처리
		// ------------------------------------
		setBeforeEach(router)
		{
			router.beforeEach(async (to, from, next) => {

				/* =====================================
                 * (1) 인증 체크 불필요
                 * ===================================== */
				if (to.matched.some(record => record.meta.auth === false)) {
					return next();
				}

				/* =====================================
                 * (2) 인증 체크 필요
                 * ===================================== */
				if (to.matched.some(record => record.meta.auth === true)) {

					// 🔑 핵심: 토큰 직접 확인 ❌
					// 로그인 상태 보장 (없으면 refresh → 실패 시 false)
					const loggedIn = await $session.ensureLoggedIn();

					if (loggedIn) {
						return next();
					}

					// 로그인 불가 → 로그인 페이지 이동
					location.href = $session.getSignInUrl();
					return;
				}

				return next();
			});
		},

		// ------------------------------------
		// 도메인 조회
		// ------------------------------------
		getDomain()
		{
			return window.location.host;
		}
	};

export {
	$router
};